import { TransportOrderModificationCause } from './transport-order-modification-cause.model';
import { CalculationMethodEnum } from './enums/calculation-method.enum';

export interface TransportOrderModification {
  id: number;
  modificationType: ModificationTypeEnum;
  comment: string;
  cause: TransportOrderModificationCause;
  contractor: string;
  date: Date;
  calculationMethod: CalculationMethodEnum;
  value: number;
  amount: number;
  owner: string;
  createdDate: Date;
  modificationBasketOrderId: number;
  transportOrderId: number;
}

export enum ModificationTypeEnum {
  REFUND = 'REFUND',
  UPDATE = 'UPDATE',
  INCIDENT = 'INCIDENT',
}
